import { render, staticRenderFns } from "./SelectBumen.vue?vue&type=template&id=45dd6871&scoped=true"
import script from "./SelectBumen.vue?vue&type=script&lang=js"
export * from "./SelectBumen.vue?vue&type=script&lang=js"
import style0 from "./SelectBumen.vue?vue&type=style&index=0&id=45dd6871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd6871",
  null
  
)

export default component.exports